export const delay = async (delay: number) =>
  await new Promise(function (resolve) {
    setTimeout(resolve, delay)
  })
